import { render, staticRenderFns } from "./lovelist.vue?vue&type=template&id=c55397d4&scoped=true&"
import script from "./lovelist.vue?vue&type=script&lang=js&"
export * from "./lovelist.vue?vue&type=script&lang=js&"
import style0 from "./lovelist.vue?vue&type=style&index=0&id=c55397d4&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55397d4",
  null
  
)

export default component.exports